import Vue from 'vue';
import Router from 'vue-router';

import Main from '@/views/Main.vue';
import IndicatorsView from '@/components/sections/indicators/IndicatorsView.vue';
import ModelsView from '@/components/sections/models/ModelsView.vue';
import BannerView from '@/components/sections/banner/BannerItem.vue';

import store from '@/store';

import authGuard from '@/util/auth-guard';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  beforeEnter: authGuard,
  routes: [{
      path: '/',
      redirect: '/indicators',
      component: Main,
      children: [{
          name: 'indicators',
          path: '/indicators',
          redirect: '/indicators/red',
          component: IndicatorsView,

          children: [
            {
              name: 'indicators-red',
              path: 'red',
              meta: {
                tableType: 'red',
                showDeleted: false,
              },
            },
            {
              name: 'indicators-yellow',
              path: 'yellow',
              meta: {
                tableType: 'yellow',
                showDeleted: false,
              },
            },
            {
              name: 'indicators-green',
              path: 'green',
              meta: {
                tableType: 'green',
                showDeleted: false,
              },
            },
          ],
        },
        {
          name: 'models',
          path: '/models',
          redirect: '/models/all',
          component: ModelsView,
          children: [{
            name: 'models-all',
            path: 'all',
            meta: {
              tableType: 'all',
              showDeleted: false,
            },
          }, ],
        },
        {
          name: 'banner',
          path: '/banner',
          component: BannerView,
        },
        {
          name: 'indicators-new',
          path: '/indicators/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/indicators/IndicatorsItem.vue'),
        },
        {
          name: 'models-new',
          path: '/models/new',
          props: {
            createMode: true,
          },
          component: () => import('@/components/sections/models/ModelsItem.vue'),
        },
        {
          name: 'indicators-item',
          path: '/indicators/:id',
          props: {
            createMode: false,
          },
          component: () => import('@/components/sections/indicators/IndicatorsItem.vue'),
        },
        {
          name: 'models-item',
          path: 'models/:id',
          props: {
            createMode: false,
          },
          component: () => import('@/components/sections/models/ModelsItem.vue'),
        },
      ],
    },
    {
      name: 'login',
      path: '/login',
      beforeEnter: (to, from, next) => {
        store.dispatch('user/logout', false);
        next();
      },
      component: () => import('@/views/Login.vue'),
    },
    {
      name: 'logout',
      path: '/logout',
      beforeEnter: (to, from, next) => {
        store.dispatch('user/logout', false);
        next({
          name: 'login'
        });
      },
    },
    {
      name: 'forbidden',
      path: '/forbidden',
      component: () => import('@/views/Forbidden.vue')
    },
    {
      name: 'auth-callback',
      path: '/auth-callback',
      component: () => import('@/views/AuthCallback.vue'),
    },
  ],
});
